'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const defaults = {
  id: null,
  repliedAt: null,
  reply: null,
  replierDisplayName: null,
  avatarUrl: null,
  companyName: null // Solutions directory only

};
/** @deprecated use marketplace-ui-reviews/records */

export default class Reply extends Immutable.Record(defaults) {
  static from(data) {
    return new Reply(cleanObject(data));
  }

}